import React from 'react';
import { Box, Stack, Text, rem } from '@mantine/core';
import type { Icon } from '@tabler/icons-react';
import { motion } from 'framer-motion';
import { POP } from '@/theme/motion';

type Props = {
    icon: Icon;
    title: string;
    body: string;
    action?: React.ReactNode;
    compact?: boolean;
};

const EmptyState: React.FC<Props> = ({ icon: Icon, title, body, action, compact = false }) => (
    <Stack align="center" justify="center" gap="sm" py={compact ? 'lg' : 'xl'} px="md" style={{ flex: 1, textAlign: 'center' }}>
        <motion.div variants={POP} initial="hidden" animate="visible">
            <Box
                style={{
                    display: 'grid', placeItems: 'center',
                    width: rem(compact ? 44 : 56), height: rem(compact ? 44 : 56),
                    borderRadius: '50%',
                    backgroundColor: 'var(--bd-brand-soft)',
                    color: 'var(--bd-brand-text)',
                }}
            >
                <Icon size={compact ? 22 : 26} stroke={1.6} />
            </Box>
        </motion.div>
        <Text fw={600} size={compact ? 'sm' : 'md'}>{title}</Text>
        <Text size="sm" c="dimmed" maw={rem(360)} lh={1.55}>{body}</Text>
        {action ? <Box mt="xs">{action}</Box> : null}
    </Stack>
);

export default EmptyState;
